<template>
  <div id="config-packages-wrapper">
    <item-tile
      v-for="(item, index) in packages"
      :key="index"
      class="package-item"
      :heading="item.name"
      :photo="item.photo"
      :selected="true"
      :secondaryIcons="['pencil']"
      @primary-icon-clicked="initiateDelete(item, index)"
      @secondary-icon-clicked="initiateEdit(item, index)"
    />
    <item-tile
      class="package-item"
      :selected="false"
      heading="Add New Package"
      @click="toggleCreationActive"
    />
    <package-creation
      v-if="creationActive"
      :package="edit.package"
      @close="toggleCreationActive"
      @add-package="callDb"
    />
    <package-delete
      v-if="del.package"
      :subject="del.package"
      :processing="del.processing"
      @close="closeDelete"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import PackageCreation from "./Modals/Packages/PackageCreation.vue";
import PackageDelete from "./Modals/Packages/Delete.vue";
import ItemTile from "@/Components/UI/ItemTile.vue";
export default {
  data() {
    return {
      creationActive: false,
      deleteActive: false,
      edit: {
        processing: false,
        package: undefined,
        index: undefined,
      },
      del: {
        processing: false,
        package: undefined,
        index: undefined,
      },
    };
  },
  computed: {
    packages() {
      return this.$store.getters.packages;
    },
  },
  methods: {
    toggleCreationActive() {
      this.creationActive = !this.creationActive;
    },
    fillArrays(subject) {
      return {
        ...subject,
        forms: subject.forms.map((subjectForm) => {
          return this.$store.getters.forms.find((storeForm) => {
            return (
              subjectForm === storeForm.id || subjectForm === storeForm.name
            );
          });
        }),
        contracts: subject.contracts.map((subjectContract) => {
          return this.$store.getters.contracts.find((storeContract) => {
            return (
              subjectContract === storeContract.id ||
              subjectContract === storeContract.name
            );
          });
        }),
        services: subject.serviceIds.map((subjectService) => {
          return this.$store.getters.services.find((storeService) => {
            return (
              subjectService === storeService.id ||
              subjectService === storeService.name
            );
          });
        }),
      };
    },
    initiateEdit(item, index) {
      this.edit.package = this.fillArrays(item);
      this.edit.index = index;
      this.toggleCreationActive();
    },
    initiateDelete(item, index) {
      this.del.package = item;
      this.del.index = index;
    },
    closeDelete() {
      this.del = {
        processing: false,
        package: undefined,
        index: undefined,
      };
    },
    async confirmDelete() {
      this.del.processing = true;
      let updatePacket = {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        index: this.del.index,
        category: "packages",
        operation: "delete",
        api_version: this.$store.state.businessSettings.api_version,
      };
      await this.$store.dispatch("updateConfig", updatePacket);
      this.closeDelete();
    },
    async callDb(subject) {
      let dbPackage = {
        name: subject.name,
        description: subject.description,
        priceOption: subject.priceOption,
        pricing: subject.pricing,
        employeesRequired: subject.employeesRequired,
        photo: subject.photo,
        id: subject.id ? subject.id : "package" + new Date().getTime(),
        forms: subject.forms
          .filter((x) => {
            return x;
          })
          .map((x) => {
            return x.id;
          }),
        contracts: subject.contracts
          .filter((x) => {
            return x;
          })
          .map((x) => {
            return x.id;
          }),
        serviceIds: subject.services
          .filter((x) => {
            return x;
          })
          .map((x) => {
            return x.id;
          }),
      };
      if (dbPackage.photo && typeof dbPackage.photo !== "string") {
        await this.$store.dispatch("addPhoto", dbPackage.photo).then((res) => {
          dbPackage.photo = res;
        });
      }
      let updatePacket;
      if (this.edit.index !== undefined) {
        updatePacket = {
          key: {
            userId: this.$store.state.user.userId,
            tenantId: this.$store.state.user.tenantId,
          },
          subject: dbPackage,
          index: this.edit.index,
          category: "packages",
          operation: "edit",
          api_version: this.$store.state.businessSettings.api_version,
        };
      } else {
        updatePacket = {
          key: {
            userId: this.$store.state.user.userId,
            tenantId: this.$store.state.user.tenantId,
          },
          subject: dbPackage,
          category: "packages",
          operation: "add",
          api_version: this.$store.state.businessSettings.api_version,
        };
      }
      await this.$store.dispatch("updateConfig", updatePacket);
      this.edit = {
        processing: false,
        automation: undefined,
        index: undefined,
      };
      this.toggleCreationActive();
    },
  },
  created() {},
  components: {
    ItemTile,
    PackageCreation,
    PackageDelete,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #config-packages-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-items: flex-start;
    box-sizing: border-box;
  }

  .package-item {
    margin: 20px;
    background-color: var(--secondaryColor);
  }
  @media (min-width: 800px) {
    .package-item {
      margin: 30px;
    }
  }
}
</style>
